import { useQuery } from '@apollo/react-hooks';
import reflectionGraph from '../../graphs/reflection';

export function useReflections() {
	const { loading, error, data } = useQuery(reflectionGraph.GET_REFLECTIONS, {
		fetchPolicy: 'cache-and-network',
	});
	return { loading, data, error };
}
